<template>
  <table class="table table-bordered mb-0" style="font-size: 0.85rem; width: 100%;">
    <tr class="bg-primary text-white">
      <th>Atividade</th>
      <th>Data/Horário</th>
      <th>Local</th>
      <th style="text-align: right">Valor</th>
    </tr>
    <tr v-for="p in atividades" v-bind:key="p.id">
      <td>{{ p.nome_completo }}</td>
      <td><span v-html="p.datas"></span></td>
      <td>{{ p.local }}</td>
      <td nowrap style="text-align: right">{{ formatPrice(p.valor) }}</td>
    </tr>
  </table>
</template>

<script>

import { baseApiUrl } from '@/global'
import axios from 'axios'

export default {
  name: 'Atividades',
  props: {
    id_compra: { type: Number }
  },
  data: function () {
    return {
      atividades: []
    }
  },
  methods: {
    carregaAtividades () {
      const url = `${baseApiUrl}/atividades_status/${this.id_compra}`
      axios.get(url).then(res => {
        this.atividades = res.data
      })
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  mounted () {
    this.carregaAtividades()
  }
}
</script>

<style scoped>
  .bg_grey {
    background-color: rgb(102, 109, 125) !important;
    color: #fff !important;
  }
</style>
